import IndexList from '../../../lib/ui/IndexControl'
import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import PersonModel from '../../person/model/PersonModel'
import OrganisationModel from '../../organisation/model/OrganisationModel'
import LocationModel from '../../location/model/LocationModel'

export default class Search {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Zoeken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        }]
    })

    let buffer = []

    let getPeople = () => {
      return new Promise((resolve, reject) => {
        window.PRIM.dataAccess.get('people').then((people) => {
          people.forEach((person) => {
            buffer.push(new PersonModel(person))
          })

          resolve()
        }, reject)
      })
    }

    let getOrganisations = () => {
      return new Promise((resolve, reject) => {
        window.PRIM.dataAccess.get('organisations').then((organisations) => {
          let promises = 0

          organisations.forEach((organisation) => {
            let model = new OrganisationModel(organisation)

            if (model.values.location_id) {
              promises++
              window.PRIM.dataAccess.get('locations', model.values.location_id).then((location) => {
                model.location = new LocationModel(location)
                buffer.push(model)

                promises--

                if (promises === 0) {
                  resolve()
                }
              }, () => {
                buffer.push(model)

                promises--

                if (promises === 0) {
                  resolve()
                }
              })
            } else {
              buffer.push(model)
            }
          })

          if (promises === 0) {
            resolve()
          }
        }, reject)
      })
    }

    /*let getLocations = () => {
      return new Promise((resolve, reject) => { {
        PRIM.dataAccess.get('locations').then( (locations) {
          let promises = 0

          locations.forEach( (location) {
            let model = new LocationModel(location)

            if (model.values.organisation_id) {
              promises++
              PRIM.dataAccess.get('organisations', model.values.organisation_id).then( (organisation) {
                model.organisation = new OrganisationModel(organisation)
                buffer.push(model)

                promises--

                if (promises === 0) {
                  resolve()
                }
              }, () => {
                buffer.push(model)

                promises--

                if (promises === 0) {
                  resolve()
                }
              })
            } else {
              buffer.push(model)
            }
          })

          if (promises === 0) {
            resolve()
          }
        }, reject)
      })
    }*/

    getPeople().then(() => {
      getOrganisations().then(() => {
        this.results.setItems(buffer)
      /*getLocations().then(() {
          results.setItems(buffer)
      });*/
      })
    })

    let onclick = (item) => {
      if (item instanceof PersonModel) {
        window.PRIM.navigate('/people/' + item.values.id)
        return
      }
      if (item instanceof OrganisationModel) {
        window.PRIM.navigate('/organisations/' + item.values.id)
        return
      }
      if (item instanceof LocationModel) {
        window.PRIM.navigate('/locations/' + item.values.id)
        return
      }
    }

    let div = document.createElement('div')
    div.className = 'viewport'

    this.results = new IndexList(div, {items: [], onclick: onclick})
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/search/action/Search.js